
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTargetCancelIec as ObiTargetCancelIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-target-cancel-iec.js';
 
 
 

 
 export const ObiTargetCancelIec = createComponent({
   react: React,
   tagName: 'obi-target-cancel-iec',
   elementClass: ObiTargetCancelIecElement,
   events: {
     
   }
  });
 
 